// basic transform support. Only simple rotate transforms are supported
"use strict";
(function ($) {
    var old_mousestart = $.ui.resizable.prototype._mouseStart,
        old_setOption = $.ui.resizable.prototype._setOption;

    $.ui.resizable.prototype._setOption = function(key, value) {
        old_setOption.apply(this, arguments);
        if (key === "aspectRatio") {
            this._aspectRatio = !!value;
        }
    };

    $.fn.getRotationMatrix = function(){
        var style = getComputedStyle(this[0]),
            t = style["transform"] || style["-webkit-transform"] || style["-moz-transform"],
            s;
        if (s = /rotate\s*\(\s*(-?[\d.]+)deg\s*\)/.exec(t)) {
            var a = parseFloat(s[1]).toRad();
            return [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a)];
        } else if (s = /matrix\s*\(\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*\)/.exec(t)) {
            return [
                parseFloat(s[1]),
                parseFloat(s[2]),
                parseFloat(s[3]),
                parseFloat(s[4])
            ];
        } else if (s = /matrix3d\(\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*\)/.exec(t)) {
            return [
                parseFloat(s[1]),
                parseFloat(s[2]),
                parseFloat(s[5]),
                parseFloat(s[6])
            ];
        } else {
            return [1, 0, 0, 1];
        }
    };
    $.fn.getRotationAngle = function(){
        var m = this.getRotationMatrix();
        return Math.atan2(m[1], m[0]);
    }

    $.ui.resizable.prototype._mouseStart = function (event) {
        old_mousestart.call(this, event);
        this.matrix = this.element.getRotationMatrix();
        this.matrix_reverse = this._matrix_reverse_rotate(this.matrix);
        return true;
    };
    $.ui.resizable.prototype._matrix_transform_center = function (m, x, y, cx, cy) {
        var c = this._matrix_transform(m, x - cx, y - cy);
        return {
            x: c.x + cx,
            y: c.y + cy
        }

    };
    $.ui.resizable.prototype._matrix_transform = function (m, x, y) {
        return {
            x: x * m[0] + y * m[2],
            y: x * m[1] + y * m[3],
        };
    };
    $.ui.resizable.prototype._matrix_reverse_rotate = function (m) {
        var a = -Math.atan2(m[1], m[0]);
        return [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a)];
    };

    $.ui.resizable.prototype._mouseDrag = function (event) {
        var data,
            el = this.helper, props = {},
            smp = this.originalMousePosition,
            a = this.axis,
            prevTop = this.position.top,
            prevLeft = this.position.left,
            prevWidth = this.size.width,
            prevHeight = this.size.height,
            dx = (event.pageX - smp.left) || 0,
            dy = (event.pageY - smp.top) || 0,
            trigger = this._change[a],
            c = this._matrix_transform(this.matrix_reverse, dx, dy);

        dx = c.x;
        dy = c.y;

        if (!trigger) {
            return false;
        }

        this._updateVirtualBoundaries(event.shiftKey);
        // Calculate the attrs that will be change
        data = trigger.apply(this, [event, dx, dy]);

        // Put this in the mouseDrag handler since the user can start pressing shift while resizing
        /*        if (this._aspectRatio || event.shiftKey) {
         data = this._updateRatio(data, event);
         }*/

        data = this._respectSize(data, event);

        this._updateCache(data);

        // plugins callbacks need to be called first
        this._propagate("resize", event);

        if (this.position.top !== prevTop) {
            props.top = this.position.top + "px";
        }
        if (this.position.left !== prevLeft) {
            props.left = this.position.left + "px";
        }
        if (this.size.width !== prevWidth) {
            props.width = this.size.width + "px";
        }
        if (this.size.height !== prevHeight) {
            props.height = this.size.height + "px";
        }
        el.css(props);

        if (!this._helper && this._proportionallyResizeElements.length) {
            this._proportionallyResize();
        }

        // Call the user callback if the element was resized
        if (!$.isEmptyObject(props)) {
            this._trigger("resize", event, this.ui());
        }

        return false;
    };

    if (!$.ui.resizable.prototype._isNumber){
        $.ui.resizable.prototype._isNumber = function isNumber(value) {
            return !isNaN(parseInt(value, 10));
        }
    }

    $.ui.resizable.prototype._respectSize2 = function (data) {
        var o = this._vBoundaries || {};
        if (this._isNumber(data.width)) {
            if (o.minWidth && (o.minWidth > data.width)){
                data.width = o.minWidth;
            }
            if (o.maxWidth && (o.maxWidth < data.width)){
                data.width = o.maxWidth;
            }
        }
        if (this._isNumber(data.height)) {
            if (o.minHeight && (o.minHeight > data.height)){
                data.height = o.minHeight;
            }
            if (o.maxHeight && (o.maxHeight < data.height)){
                data.height = o.maxHeight;
            }
        }
        return data;
    };

    $.ui.resizable.prototype._change = {
        e: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_w = Math.max(cs.width + dx, 0),
                new_h = (this._aspectRatio || event.shiftKey) ? new_w / this.aspectRatio : cs.height,
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - top left corner
                corner = this._matrix_transform_center(mr, 0, 0, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(mr, 0, 0, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(m, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top - t.y,
                "left": sp.left - t.x,
            };
        },
        w: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_w = Math.max(cs.width - dx, 0),
                new_h = (this._aspectRatio || event.shiftKey) ? new_w / this.aspectRatio : cs.height,
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - top right corner
                corner = this._matrix_transform_center(m, cs.width, 0, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(m, ns.width, 0, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(mr, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top - t.y,
                "left": sp.left + t.x,
            };
        },
        n: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height - dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : cs.width,
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - bottom right corner
                corner = this._matrix_transform_center(m, 0, cs.height, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(m, 0, ns.height, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(mr, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top + t.y,
                "left": sp.left - t.x,
            };
        },
        s: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height + dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : cs.width,
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - top left corner
                corner = this._matrix_transform_center(mr, 0, 0, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(mr, 0, 0, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(m, corner.x - new_corner.x, corner.y - new_corner.y);
            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top - t.y,
                "left": sp.left - t.x
            };
        },
        se: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height + dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : Math.max(cs.width + dx, 0),
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - top left corner
                corner = this._matrix_transform_center(mr, 0, 0, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(mr, 0, 0, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(m, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top - t.y,
                "left": sp.left - t.x,
            };
        },
        sw: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height + dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : Math.max(cs.width - dx, 0),
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - top right corner
                corner = this._matrix_transform_center(m, cs.width, 0, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(m, ns.width, 0, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(mr, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top - t.y,
                "left": sp.left + t.x,
            };
        },
        ne: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height - dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : Math.max(cs.width + dx, 0),
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - bottom left corner
                corner = this._matrix_transform_center(m, 0, cs.height, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(m, 0, ns.height, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(mr, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top + t.y,
                "left": sp.left - t.x,
            };
        },
        nw: function (event, dx, dy) {
            var cs = this.originalSize,
                sp = this.originalPosition,
                m = this.matrix,
                mr = this.matrix_reverse,
                new_h = Math.max(cs.height - dy, 0),
                new_w = (this._aspectRatio || event.shiftKey) ? new_h * this.aspectRatio : Math.max(cs.width - dx, 0),
                ns = this._respectSize2({"width": new_w, "height": new_h}),
                // sentinel point - bottom right corner
                corner = this._matrix_transform_center(mr, cs.width, cs.height, cs.width / 2, cs.height / 2),
                new_corner = this._matrix_transform_center(mr, ns.width, ns.height, ns.width / 2, ns.height / 2),
                t = this._matrix_transform(m, corner.x - new_corner.x, corner.y - new_corner.y);

            return {
                "width": ns.width,
                "height": ns.height,
                "top": sp.top + t.y,
                "left": sp.left + t.x,
            };
        }
    };
})(jQuery);
